import React, { lazy, Suspense, Fragment } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Spin } from 'antd'

import { SessionExpiredModal } from '@pepper/ui'

import Home from 'container/Home/Home'
import Projects from 'container/Projects/LiveProjects/LiveProjects'
import Project from 'container/Projects/LiveProjects/Project/Project'
import ContentRefresh from 'container/SEOTools/ContentRefresh/ContentRefresh'
import ContentGapReport from 'container/SEOTools/ContentGapReport/ContentGapReport'
import ContentRoi from 'container/SEOTools/ContentRoi/ContentRoi'
import ErrorTemplate from 'components/ErrorTemplate/ErrorTemplate'

import styles from './_.module.css'

const routes = [
  {
    path: '/',
    component: Home,
    exact: true,
  },
  {
    path: '/home',
    component: Home,
    exact: true,
  },
  {
    path: '/projects',
    component: Projects,
    exact: true,
  },
  {
    path: '/projects/items',
    component: Projects,
    exact: true,
  },
  {
    path: '/project/:projectId',
    component: Project,
    exact: true,
  },
  {
    path: '/project/:projectId/:tab',
    component: Project,
    exact: true,
  },
  {
    path: '/assignment/:assignment_id',
    component: lazy(
      () => import('container/AssignmentDetails/AssignmentDetails')
    ),
    exact: false,
  },
  {
    path: '/personal-settings',
    component: lazy(() => import('container/Profile/Profile')),
    exact: false,
  },
  {
    path: '/admin-console',
    component: lazy(() => import('container/Profile/Profile')),
    exact: false,
  },
  {
    path: '/content-refresh',
    component: ContentRefresh,
    exact: true,
  },
  {
    path: '/content-refresh/:reportId/report/:documentId',
    component: ContentGapReport,
    exact: true,
  },
  {
    path: '/invoices',
    component: lazy(() => import('container/Invoices/Invoices')),
    exact: false,
  },
  {
    path: '/roi',
    component: ContentRoi,
    exact: false,
  },
  {
    path: '/content-ideas',
    component: lazy(() => import('container/ContentIdeas')),
    exact: false,
  },
  {
    path: '/content-studio',
    component: lazy(() => import('container/ContentStudio/ContentStudio')),
    exact: true,
  },
  {
    path: '/content-studio/chat',
    component: lazy(
      () => import('container/ContentStudioChat/ContentStudioChat')
    ),
    exact: true,
  },
  {
    path: '/content-studio/app',
    component: lazy(
      () => import('container/ContentStudioApp/ContentStudioApp')
    ),
    exact: true,
  },
  {
    path: '/asset-manager',
    component: lazy(() => import('container/AssetManager/AssetManager')),
    exact: true,
  },
  {
    path: '*',
    component: () => (
      <div className={styles.wrapper}>
        <ErrorTemplate
          statusCode={404}
          error={{ title: '404', message: 'Error 404: Page Not Found' }}
        />
      </div>
    ),
    exact: false,
  },
]

const DashboardRouter: React.FC = () => {
  return (
    <Fragment>
      <SessionExpiredModal />
      <Suspense fallback={<Spin className="spinner-full" />}>
        <Switch>
          {routes.map((route, idx) => (
            <Route
              exact={route.exact}
              key={idx}
              path={route.path}
              component={route.component}
            />
          ))}
        </Switch>
      </Suspense>
    </Fragment>
  )
}

export default DashboardRouter
